<div class="row" *ngIf="inspection">
  <json-edit
    [object]="inspection"
    [processing]="processing"
    [type]="'Inspection'"
    (toggleSave)="saveInspection($event)"
    (toggleCancel)="cancel()"
  ></json-edit>
</div>
